/// Onboarding Icons
import onboardingImage from "assets/images/onboading-video-placeholder.jpg";
import onboardingCredentialing_white from "assets/icons_services_onboarding/provider-credentialing-white 1.svg";
import onboardingEnrollment_white from "assets/icons_services_onboarding/Payor-Enrollment-White.svg";
import onboardingMonitoring_white from "assets/icons_services_onboarding/Monitering-and-Tracking-White.svg";
import onboardingHandshake from "assets/icons_services_onboarding/handshake-gray 1.svg";
import onboardingHandshake_white from "assets/icons_services_onboarding/handshake-white 1.svg";
import onboardingEnrollment from "assets/icons_services_onboarding/Payor-Enrollment-Gray.svg";
import onboardingMonitoring from "assets/icons_services_onboarding/Monitering-and-Tracking-Gray.svg";
import onboardingCredentialing from "assets/icons_services_onboarding/provider-credentialing-gray 1.svg";

/// Vendor Services Icons
import Data_Manage from "assets/icons_services_onboarding/data-management.svg";
import Data_Manage_White from "assets/icons_services_onboarding/data-management-white.svg";
import Security_Risk from "assets/icons_services_onboarding/security-audit.svg";
import Security_Risk_White from "assets/icons_services_onboarding/security-audit-white2.svg";
import Vendor_Cred from "assets/icons_services_onboarding/VRA - Gray.svg";
import Vendor_Cred_White from "assets/icons_services_onboarding/VRA - White.svg";

/// Hero Strengths Icons
import expertLed from "assets/icons_hero/Expert-led-Processes.svg";
import timeAndCostSavings from "assets/icons_hero/Time-And-Cost-Savings.svg";
import proactiveRiskManagement from "assets/icons_hero/Proactive-Risk-Management.svg";
import customizableSolutions from "assets/icons_hero/Customizable-Solutions.svg";
import realTimeUpdates from "assets/icons_hero/Real-Time-Updates.svg";
import streamlineWorkflows from "assets/icons_hero/Streamline-Workflows.svg";
import Healthcare_Providers from "assets/icons_services_whoweserve/Healthcare_Providers.png";
import Healthcare_Support_Services from "assets/icons_services_whoweserve/Healthcare_Support_Services.png";
import Healthcare_Providers_White from "assets/icons_services_whoweserve/Healthcare_Providers_White.png";
import Healthcare_Support_Services_White from "assets/icons_services_whoweserve/Healthcare_Support_Services_Black.png";


const iconMap = {
    onboardingImage,
    onboardingCredentialing_white,
    onboardingEnrollment_white,
    onboardingMonitoring_white,
    onboardingHandshake,
    onboardingHandshake_white,
    onboardingEnrollment,
    onboardingMonitoring,
    onboardingCredentialing,
    Data_Manage,
    Data_Manage_White,
    Security_Risk,
    Security_Risk_White,
    Vendor_Cred,
    Vendor_Cred_White,
    expertLed,
    timeAndCostSavings,
    proactiveRiskManagement,
    customizableSolutions,
    realTimeUpdates,
    streamlineWorkflows,
    Healthcare_Providers,
    Healthcare_Providers_White,
    Healthcare_Support_Services,
    Healthcare_Support_Services_White
};

export default function mapIcons(service) {
    return {
        ...service,
        activeIcon: iconMap[service.activeIcon],
        icon: iconMap[service.icon],
    };
}
